import { useEffect } from "react";
import { Button, Card, Col, Container, Navbar, Row } from 'react-bootstrap';
import Select, { SingleValue } from 'react-select';
import useFilters from "@oldDashboard/legacyHooks/useFilters";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";
import { Launches } from "@oldDashboard/legacyModels/launches.model";
import Loader from "@/components/common/loader/loader";
import  store  from '@oldDashboard/rootStore';
import { useSnapshot } from "valtio";
import { searchDashboardClient, selectLaunchAction, selectTimePeriodAction } from "@oldDashboard/legacyActions/dashboardClient";
import { selectAffiliateAction } from "@oldDashboard/legacyActions/account";

type AffiliateOption = { value: string; label: string };

const Filters = ()  => {
    const { dashboardState, accountState } = store;
    const { affiliateSelected, affiliates } = accountState.state as { affiliateSelected: string; affiliates: AffiliateOption[] };
    const { launches, searching, launchSelected, timePeriodSelected, timePeriods } = dashboardState.state;
    useSnapshot(accountState);
    useSnapshot(dashboardState.state);
    const {fetchLaunches, fetchAffiliates, isLoading} = useFilters({affiliateSelected, launchSelected});

     useEffect(()=>{
        fetchLaunches();
        fetchAffiliates();
    },[]);

    useEffect( () => {
        fetchLaunches();
    }, [affiliateSelected, launchSelected]);

    const changeAffiliate = (opt: SingleValue<AffiliateOption>) => {
        if (opt) selectAffiliateAction(opt.value);
    }

    const changeLaunch = (launch: SingleValue<Launches>) => {
       selectLaunchAction(launch!.value);
    }

    const changePeriod = (period: SingleValue<TimePeriods>) => {
        selectTimePeriodAction(period!.key);
    }

    const search = async () => {
        searchDashboardClient(!searching);
    }
    
    return(
        <Row> 
            <Col md={12}>
                <Card className="custom-card products-navigation-card">
                    <Card.Body className="card-body p-0">
                        <Navbar>
                            <Container fluid>
                                <Navbar.Collapse className="collapse navbar-collapse navbar-justified flex-wrap gap-2" id="navbarSupportedContent">
                                       <Container fluid>
                                            <div className="row">
                                                { isLoading && <Loader/> }
                                                <div className="col-md-4 mb-2 mb-md-0">
                                                    <div className="row d-flex align-items-center">
                                                        <div className="d-flex align-items-center px-0" style={{maxWidth:"550px"}}>
                                                            <p className="mb-0 fs-16 fw-semibold mx-2 mx-sm-1">Affiliate</p>
                                                            <Select<AffiliateOption, false>
                                                                options={affiliates}
                                                                className="basic ml-2 w-100"
                                                                menuPlacement='bottom'
                                                                onChange={changeAffiliate}
                                                                classNamePrefix="Select2"
                                                                value={affiliates.find((a) => a.value === affiliateSelected) ?? null}
                                                                placeholder="Select..." />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mb-2 mb-md-0">
                                                    <div className="row d-flex align-items-center">
                                                        <div className="d-flex align-items-center px-0" style={{maxWidth:"550px"}}>
                                                            <p className="mb-0 fs-16 fw-semibold mx-2 mx-sm-1" >Launch</p>
                                                            <Select
                                                                options={launches}
                                                                className="basic ml-2 w-100"
                                                                menuPlacement='bottom'
                                                                onChange={(launch)=>{changeLaunch(launch)}}
                                                                classNamePrefix="Select2"
                                                                value={launches.find(({value}: {value:string}) => value == launchSelected)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="row d-flex align-items-center">
                                                        <div className="d-flex align-items-center px-sm-1">
                                                            <p className="mb-0 fs-16 fw-semibold mx-0 mx-md-2" >Date Range</p>
                                                            <Select
                                                                options={timePeriods}
                                                                className="basic w-100"
                                                                menuPlacement='bottom'
                                                                onChange={(period)=>{changePeriod(period)}}
                                                                classNamePrefix="Select2"
                                                                value={timePeriods.find(({key}: {key:string}) => key === timePeriodSelected.toString())}
                                                                />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-1 d-flex justify-content-end ">
                                                    <Button variant='' onClick={search}  className="btn btn-light"type="submit">Search</Button>
                                                </div>
                                            </div>
                                       </Container>
                                </Navbar.Collapse>
                            </Container>
                        </Navbar>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );

}

export default (Filters);